// removed by extract-text-webpack-plugin
module.exports = {"list-item":"GpAl1DZz","title-container":"DwAaW9H-","secondary-workout-container":"_2l5msESY","workout-container":"_3b7ENHKY","circuit-row":"_3InOKIgC","table-container":"_2sCT-usj","value-cell":"_1n9-HUSG","down-arrow":"_2Sa94mYR","rotate":"_3Ewk9PLl","circuit-inactive":"_25fBeti_","circuit-active":"_21d3we8C","inactive":"_2LEH3ZZq","closed":"_2MYEZDf0"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/WeekWorkoutSummary/WeekWorkoutSummary.styl
// module id = 408
// module chunks = 0